import type { SchedulingAvailabilityInfo } from '@carvana/merch-contracts';

export default function getSoonestRoute(
  delivery: SchedulingAvailabilityInfo | undefined,
  pickup: SchedulingAvailabilityInfo | undefined
): SchedulingAvailabilityInfo | undefined {
  if (pickup == null) return delivery;
  if (delivery == null) return pickup;
  if (pickup.drivingMiles > 150) return delivery;

  return delivery.daysToAvailability < pickup.daysToAvailability
    ? delivery
    : pickup;
}
